<template>
    <div class="tracking-cases">
        <b-card no-body class="p-3 mb-3">
            <DisableCaseCard :product="product"/>
            <b-row>
                <b-col cols="12" md="4" class="border-right cursor-pointer"  @click="$refs.case_details_drawer.show(product.prod_id)">
                    <div class="mb-2">
                        <b-badge class="text-white font-weight-400 badge-id mr-1">ID</b-badge>
                        <span class="text-muted text-xs">{{ product.prod_id }} | Created in {{ product.prod_created_date | dateFormatString }}</span>
                    </div>
                    <div class="my-2">
                        <template v-if="product.product_detail.prod_pm_property_src != 'HESTIA'">
                            <span class="badge py-1" :style="{'background': CASE_COLOR[product.prod_main_status]}">{{ product.prod_main_status }}</span>
                            <span class="badge badge-primary m-2 py-1" >PMP</span>
                        </template>
                        <template v-else>
                            <span class="badge py-1" :style="{'background': CASE_COLOR[product.prod_sas_prop_main_status]}">{{ product.prod_sas_prop_main_status }}</span>
                            <span class="badge badge-warning m-2 py-1" >HESTIA</span>
                        </template>
                    </div>
                    <div>
                        <div class="d-flex align-items-start">
                            <el-image
                                style="width: 40px; height: 40px"
                                class="rounded"
                                :src="product.prod_image_url"
                                fit="cover">
                            </el-image>
                            <b-row>
                                <b-col cols="12" class="text-muted ml-2">
                                    <p class="font-weight-500">{{ product.product_detail.prod_pm_project_name }}</p>
                                    <p class="text-xs">{{ product.product_detail.prod_pm_unit_no }}</p>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="mt-3">
                            <p class="text-xs text-muted">Total SPA</p>
                            <h3>RM{{ product.product_detail.prod_pm_spa_price | moneyFormatter }}</h3>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="8" class="tracking-status d-flex flex-column justify-content-between">
                    <div class="d-flex justify-content-between">
                        <p class="font-weight-500">Tracking Status</p>
                        <div>
                            <!-- <span class="text-success text-xs">
                                <span class="font-weight-600">Payment Done</span>
                                at
                                <span class="font-weight-600">23 Nov 2022</span>
                            </span> -->
                            <!-- <el-dropdown trigger="click" class="cursor-pointer">
                                <b class="el-dropdown-link">
                                    <b-icon icon="three-dots-vertical">
                                    </b-icon>
                                </b>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="mr-2" viewBox="0 0 512 512"><path fill="#293854" d="m362.7 19.3-48.4 48.4 130 130 48.4-48.4c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2c-2.5 8.5-.2 17.6 6 23.8s15.3 8.5 23.7 6.1L151 475.7c14.1-4.2 27-11.8 37.4-22.2l233.3-233.2-130-130z"/></svg>
                                        View Invoice
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->
                        </div>
                    </div>
                    <b-container>
                        <b-row class="d-flex align-items-center rounded mt-2 py-1" style="background: #F6F9FD;"
                            v-for="bank in product.product_banks"
                            :key="bank.prod_bnk_id"
                        >
                            <b-col cols="3" class="pl-2 d-flex align-items-center text-truncate pl-0">
                                <b-button variant="primary" class="p-1 m-2" v-if="auth_user.subscription.privileges.scpk_crm_chat_massage">
                                    <!-- <el-badge :value="20" :max="5" class="item"> -->
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 24 24" class="mx-0"><path fill="currentColor" fill-rule="evenodd" d="M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-3.586l-3.707 3.707A1 1 0 0 1 6 17v-3H5a3 3 0 0 1-3-3V5zm20 4v6c0 1-.6 3-3 3h-1v3c0 .333-.2 1-1 1-.203 0-.368-.043-.5-.113L12.613 18H9l3-3h3c1.333 0 4-.8 4-4V6c1 0 3 .6 3 3z" clip-rule="evenodd"/></svg>
                                    <!-- </el-badge> -->
                                </b-button>
                                <p v-if="bank.prod_bnk_banker_detail">{{bank.prod_bnk_banker_detail.name}}</p>
                                <p v-else>N/A</p>
                            </b-col>
                            <b-col cols="3" class="text-truncate">
                                <el-image
                                    class="rounded mr-2"
                                    :src="bank.prod_bnk_logo_url"
                                    fit="cover"
                                    style="height: 15px;"
                                ></el-image>
                            </b-col>
                            <b-col cols="2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256"><path fill="currentColor" d="M24 102h26v68H32a6 6 0 0 0 0 12h192a6 6 0 0 0 0-12h-18v-68h26a6 6 0 0 0 3.14-11.11l-104-64a6 6 0 0 0-6.28 0l-104 64A6 6 0 0 0 24 102Zm38 0h36v68H62Zm84 0v68h-36v-68Zm48 68h-36v-68h36ZM128 39l82.8 51H45.2Zm118 169a6 6 0 0 1-6 6H16a6 6 0 0 1 0-12h224a6 6 0 0 1 6 6Z"/></svg>
                                LO
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <b-badge pill class="text-white font-weight-500 bg-primary">{{ bank.prod_bnk_stage_status }}</b-badge>
                            </b-col>
                            <div class="d-flex  justify-content-between w-100 px-2 my-0 py-0" v-if="bank.prod_bnk_submission_date">
                                <small>Submitted: {{ bank.prod_bnk_submission_date | dateTimeFormatString }}</small>
                                <small v-if="bank.prod_bnk_lo_sign_date"><i class="fa fa fa-signature"></i> {{ bank.prod_bnk_lo_sign_date | dateTimeFormatString }}</small>
                            </div>
                            <!-- <b-col class="pr-0 text-danger">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                                30d
                            </b-col> -->
                        </b-row>
                    </b-container>
                    <b-container>
                        <b-row>
                            <b-col cols="12" class="px-0 pt-3 mb-2">
                                <span class="text-muted pr-2 font-weight-bold">Total Banks Apply</span>
                                <span>{{ product.product_banks.length }}</span>
                            </b-col>
                            <b-col cols="12" class="px-0 mb-2" v-if="selectedBank && selectedBank.prod_bnk_spa_status">
                                <div class="d-flex justify-content-between w-100">
                                    <div class="text-muted font-weight-bold my-auto d-flex align-items-center">
                                        <span class="mr-1">SPA Status: </span> 
                                        <span class="badge badge-success">{{ selectedBank.prod_bnk_spa_status }}</span>
                                    </div>
                                    <div v-if="selectedBank.prod_bnk_spa_sign_date">
                                        <small><i class="fa fa fa-signature"></i> {{ selectedBank.prod_bnk_spa_sign_date | dateTimeFormatString}}</small>
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="12" class="px-0" v-if="selectedBank && selectedBank.prod_bnk_la_status">
                                <div class="d-flex justify-content-between w-100">
                                    <div class="text-muted font-weight-bold my-auto d-flex align-items-center">
                                        <span class="mr-1">LA Status: </span> 
                                        <span class="badge badge-success">{{ selectedBank.prod_bnk_la_status }}</span>
                                    </div>
                                    <div v-if="selectedBank.prod_bnk_la_sign_date">
                                        <small><i class="fa fa fa-signature"></i> {{ selectedBank.prod_bnk_la_sign_date | dateTimeFormatString}}</small>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
            </b-row>
        </b-card>

        <case-details-drawer ref="case_details_drawer" :product="product"></case-details-drawer>
    </div>
</template>
<script>
import { Dropdown, DropdownItem, DropdownMenu, Image } from 'element-ui'
import CaseDetailsDrawer from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/CaseDetailsDrawer'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import {
    notifyFunctionMixin,
} from '@/assets/js/httpImports.js'
import DisableCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/DisableCaseCard'
import {CASE_COLOR} from '@/assets/js/colors.js'
import { useAuthStore } from '@/stores/authStore'

export default {
    props: ['product'],
    components: {
        DisableCaseCard,
        CaseDetailsDrawer,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Image.name]: Image,
    },
    mixins: [notifyFunctionMixin],
    data(){
        return{
            CASE_COLOR:CASE_COLOR,
        }
    },
    computed:{
        ...mapState(useAuthStore,['auth_user']),
        selectedBank(){
            let bank = null
            bank = this.product.product_banks.find((item) => item.prod_bnk_spa_status !== null || item.prod_bnk_la_status !== null)
            return bank
        }
    },
    methods: {
        ...mapActions(useProductStore, ['removeProduct']),
        getClockIconColor(created_at) {
            const date = new Date(created_at);
            const currentDate = new Date();
            const differenceInDays = Math.floor((currentDate - date) / (1000 * 60 * 60 * 24));
            
            if (differenceInDays > 7) {
                return 'text-danger'; // Change to red color class
            } else if (differenceInDays > 3) {
                return 'text-warning'; // Change to yellow color class
            } else {
                return 'text-success'; // Change to green color class
            }
        },
        async removeProductHandler(){
            try{
                await this.removeProduct(this.product)
                this.notifySuccess('<b>Case</b> - Successfully Removed.')
            }catch(e){
                this.errorFunction(null, e)
            }
        }
    }
}
</script>